module.exports = __webpack_public_path__ + "static/img/030.ca29214.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/datav-gejiachecun/030.png
// module id = GgIA
// module chunks = 1